export const getAbbreviatedCoachName = (coachName: string | undefined | null) => {
  if (!coachName) {
    return null
  }
  const [firstName, secondName, ..._] = coachName.split(' ')

  return secondName ? `${firstName} ${secondName.charAt(0)}.` : firstName
}
